import gql from 'graphql-tag';

export default gql`
  mutation deleteInstruction($id: ID!) {
    instruction: deleteInstruction(id: $id) {
      id
    }
  }
`;
